const root = "LoginHelpScreen";

const LoginHelpEvents = {
    CLICK: `${root}.click`,
    CTA_BUTTON: `${root}.ctaButton`,
    TRY_AGAIN: `${root}.tryAgain`
};

export default LoginHelpEvents;
